module.exports = __webpack_public_path__ + "img/incantalia-collezione-prodotti.8c7b4444.jpg";